import * as React from 'react'

import { Break, breakPoints } from '../index.js'

export function useCurrentBreakPoint(): Break | null {
    const [breakPoint, setBreakPoint] = React.useState<Break | null>(null)

    React.useEffect(() => {
        const resizeListener = () => {
            const sortedBreakPoints = (Object.keys(breakPoints) as Break[]).sort(
                (x, y) => breakPoints[y] - breakPoints[x],
            )

            const bp = sortedBreakPoints.find(
                (sortedBreakPoint) => window.matchMedia(`(min-width: ${breakPoints[sortedBreakPoint]}px)`).matches,
            )

            setBreakPoint(bp || 'xs')
        }

        window.addEventListener('resize', resizeListener)
        resizeListener()

        return () => {
            window.removeEventListener('resize', resizeListener)
        }
    }, [])

    return breakPoint
}
